// @rails/ujs (Coach) hands its handlers `event.detail = [response, statusText, xhr]`, with the
// response already parsed and no jQuery `responseJSON`; jquery-ujs passes (xhr, status, error);
// the multipart bridge (ajax_helpers.js) fires `detail = [jqXHR, status, error]`. All three reach
// errorFunc as a jQuery-style xhr.
export function ajaxErrorArgs(event, xhr, error, message) {
  const detail = event.originalEvent?.detail ?? event.detail
  if (xhr || !Array.isArray(detail)) return [xhr, error, message]

  // Already a jqXHR (the multipart bridge): it has its own responseJSON.
  if (detail[0] && typeof detail[0].getResponseHeader === 'function')
    return [detail[0], detail[1], detail[2]]

  const [response, statusText, nativeXhr] = detail
  const responseJSON =
    response && typeof response === 'object' ? response : undefined
  return [
    nativeXhr && {
      status: nativeXhr.status,
      responseText: nativeXhr.responseText,
      responseJSON,
    },
    'error',
    statusText,
  ]
}
